import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="notfound-page">
      <title>Seite nicht gefunden – Nexite IT</title>
      <meta name="robots" content="noindex, nofollow" />

      <div className="notfound-content">
        <h1 className="notfound-code">404</h1>
        <h2 className="notfound-title">Seite nicht gefunden</h2>
        <p className="notfound-text">
          Die gesuchte Seite wurde möglicherweise entfernt, umbenannt oder ist
          vorübergehend nicht erreichbar.
        </p>
        <Link to="/" className="notfound-button">
          <i className="bi bi-house-door-fill" aria-hidden="true"></i> Zur Startseite
        </Link>
      </div>

      <div className="notfound-visual" aria-hidden="true">
        <div className="notfound-circle"></div>
        <i className="bi bi-question-circle"></i>
      </div>
    </div>
  );
};

export default NotFound;
